import { stevieCam } from '../engine/stevieCam-sidecar'
import { common } from './../main/common-sidecar'

export const create = () => {
  let s = common.getPhaserScene()
  s.input.on(
    'wheel',
    (
      pointer: any,
      currentlyOver: any,
      dx: number,
      dy: number,
      dz: number,
      event: any,
    ) => {
      stevieCam.mouseWheelZoom(dx + dy + dz)
    },
  )
}
